import { createSelector, createAction, createSlice } from '@reduxjs/toolkit';
import { schema, normalize } from 'normalizr';

const appt = new schema.Entity('appointments');

export const fetchPatientProfile = createAction('patient/fetchPatientProfile');
export const fetchPatientFolder = createAction('patient/fetchPatientFolder');
export const fetchFolderDocsByPatientId = createAction('patient/fetchFolderDocsByPatientId');

export const ptFoldersSelector = createSelector(
  (state) => state.patient.folders,
  (subState) => subState,
);

export const activeFolderDocsSelector = createSelector(
  (state) => state.patient.folderDocs,
  (state) => state.patient.activeFolderItem,
  (docs, activeItem) => docs[activeItem] || [],
);

export const normalizedPatientApptsSelector = createSelector(
  (state) => state.patient.appointments,
  (subState) => subState,
);

export const patientAppointmentIdsSelector = createSelector(
  (state) => state.patient.appointmentIds,
  (subState) => subState,
);

const patientSlice = createSlice({
  name: 'patient',
  initialState: {
    patient: {},
    ptEditPane: false,
    folderDocs: {},
    folders: [],
    activeFolderItem: null,
    activeFolderTitle: null,
    appointmentIds: [],
    appointments: {},
  },
  reducers: {
    fetchPatientProfileSuccess(state, action) {
      const { data = {} } = action.payload;
      state.patient = data;
    },

    togglePtEditPane(state, action) {
      state.ptEditPane = action.payload || !state.ptEditPane;
    },
    fetchPatientFolderSuccess(state, action) {
      const { data } = action.payload;
      state.folders = data;
    },
    fetchFolderDocsByPatientIdSuccess(state, action) {
      const { data, apiKey, title } = action.payload;
      state.activeFolderItem = apiKey;
      state.folderDocs[apiKey] = data;
      state.activeFolderTitle = title;
    },
    normalizePatientAppts(state, action) {
      const { data } = action.payload;
      const normalizeAppts = normalize(data, [appt]);
      state.appointments = normalizeAppts?.entities?.appointments;
      state.appointmentIds = normalizeAppts?.result;
    },
  },
});

export const { fetchPatientProfileSuccess, togglePtEditPane, fetchFolderDocsByPatientIdSuccess, fetchPatientFolderSuccess, normalizePatientAppts } = patientSlice.actions;

export default patientSlice.reducer;
